import { AppContext, Features } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { Link, withRouter } from 'react-router-dom';
import GlobalHelper from "../../common/GlobalHelper.jsx";
import Icon from "../../common/icon/icon.component.jsx";
import LoadingSpinner from "../../common/spinner/loading.component.jsx";
import AddressComponent from "../../customer/components/AddressComponent";
import CustomerSelect from '../../customer/selection.component.jsx';

class ProjectCustomerEditForm extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            modal: '',
            contactId: '',
            contactPrimaryPhoneNumber: '',
            contactPrimaryPhoneNumberExtension: '',
            contactMobilePhoneNumber: '',
            contactCompany: null, //the company whose the contact belongs to
            contact: null,
            showEmptyBox: false,
            showCustomerSelected: false,
            customerSelected: '',
            initialContactId: this.props.initialContactId || '',
            showLoyaltyBalance: this.props.showLoyaltyBalance || false,
            loyaltyBalance: '',
            isCustomerEditable: this.props.isCustomerEditable || false,
            loading: this.props.skipContactCreation || false,
            showCustomerSectionInfoBanner: false,
            renderContactEnabled: this.props.renderContactEnabled || false,
            skipContactCreation: this.props.skipContactCreation || false,
        }
        const defaultCallback = () => { }
        this.onChange = this.props.onChange || defaultCallback
        this.className = this.props.className || ''
        this.openCustomerSelector = this.openCustomerSelector.bind(this)
        this.handleCustomerSelectedChange = this.handleCustomerSelectedChange.bind(this)
        this.selectCustomer = this.selectCustomer.bind(this)
        this.cancelCustomerSelector = this.cancelCustomerSelector.bind(this)
        this.removeContact = this.removeContact.bind(this)
        this.displayInfoCustomerFirstBanner = this.displayInfoCustomerFirstBanner.bind(this)
    }

    componentDidMount() {
        const contactId = this.props.value || this.state.initialContactId || ''
        if (contactId) {
            this.setState({
                showEmptyBox: false,
                showCustomerSelected: false,
            })
            this.loadContact(contactId)
        }
    }

    componentWillReceiveProps(nextProps) {
        const contactId = nextProps.value || ''
        if (contactId) {
            this.setState({
                showEmptyBox: false,
                showCustomerSelected: false,
                isCustomerEditable: nextProps.isCustomerEditable || false,
            })
            this.loadContact(contactId)
        }

        this.setState({
            showCustomerSectionInfoBanner: nextProps.showCustomerSectionInfoBanner,
            initialContactId: nextProps.initialContactId,
        })
    }

    openCustomerSelector(e) {
        this.setState({
            showCustomerSelected: true
        })

        if (e) {
            e.preventDefault()
        }
    }

    selectCustomer(e) {
        if (this.state.customerSelected) {
            this.setState({
                showCustomerSelected: false,
                showEmptyBox: false
            })
            this.loadContact(this.state.customerSelected, () => {
                this.onChange(this.state.customerSelected, this.state.contact.attributes.name)
            })
        }
        e.preventDefault()
    }

    cancelCustomerSelector(e) {
        this.setState({
            showCustomerSelected: false,
            showEmptyBox: false
        })
        if (!this.state.renderContactEnabled) {
            this.onChange('', '')
        }
        e.preventDefault()
    }

    loadContact(contactId, callback) {
        const next = callback || function () { }

        if (this.state.contactId === contactId) {
            return
        }

        this.setState({
            loading: true,
        })
        const promiseContact = AppContext.getApiClient().get('/contacts/' + contactId)
        const promiseNestedCompany = promiseContact.then(function (contact) {
            if (contact.type === "persons" && contact.attributes.organizationId) {
                return AppContext.getApiClient().get('/contacts/' + contact.attributes.organizationId).then(company => {
                    let contactCompany = null
                    if (company && company.type === "organizations") {
                        contactCompany = company
                    }
                    return contactCompany
                }
                )
            }
            else {
                return Promise.resolve()
            }
        })
        if (this.state.showLoyaltyBalance && AppContext.hasFeatureIntegration(Features.LoyaltyRedemption)) {
            AppContext.getApiClient().get('/contacts/' + contactId + '/loyalty-customers').then(l => {
                this.setState({
                    loyaltyBalance: l.attributes.pointsBalance,
                })
            })
        }
        Promise.all([promiseContact, promiseNestedCompany]).then(([contact, company]) => {

            let contactPrimaryPhoneNumber = ''
            let contactPrimaryPhoneNumberExtension = ''
            let contactMobilePhoneNumber = ''

            for (let i = 0; i < contact.attributes.phoneNumbers.length; i++) {
                if (contact.attributes.phoneNumbers[i]["type"] == "primary") {
                    contactPrimaryPhoneNumber = contact.attributes.phoneNumbers[i]["phoneNumber"]
                    contactPrimaryPhoneNumberExtension = contact.attributes.phoneNumbers[i]["extension"]
                }
                if (contact.attributes.phoneNumbers[i]["type"] == "mobile") {
                    contactMobilePhoneNumber = contact.attributes.phoneNumbers[i]["phoneNumber"]
                }
            }

            this.setState({
                contactId: contactId,
                contact: contact,
                showEmptyBox: false,
                showCustomerSelected: false,
                contactPrimaryPhoneNumber: contactPrimaryPhoneNumber,
                contactPrimaryPhoneNumberExtension: contactPrimaryPhoneNumberExtension,
                contactMobilePhoneNumber: contactMobilePhoneNumber,
                contactCompany: company,
                loading: false,
            }, () => {
                next()
            })
        })
    }

    handleCustomerSelectedChange(customerId) {
        this.setState({
            customerSelected: customerId,
        })
    }

    removeContact(e) {
        e.preventDefault()
        this.setState({
            showEmptyBox: true,
            customerSelected: '',
            contactId: '',
        }, () => {
            // this.onChange('')
        })
    }

    renderCustomerSelector() {
        return <div className="" >
            <div className="py-2">
                <CustomerSelect contactType={'persons'} value={this.state.customerSelected} onChange={this.handleCustomerSelectedChange} />
            </div>
            <p className="pt-2 text-align-center">
                <a href="#" className="btn btn-light btn-sm" onClick={this.cancelCustomerSelector}>
                    <FormattedMessage
                        id="quote.edit.project.customer.cancel_select_btn"
                        defaultMessage="Cancel"
                    />
                </a>
                &nbsp;
                &nbsp;
                <a href="#" className="btn btn-primary btn-sm" onClick={this.selectCustomer}>
                    <FormattedMessage
                        id="quote.edit.project.customer.select_btn"
                        defaultMessage="Submit"
                    />
                </a>
            </p>

        </div>
    }

    renderEmptyBox() {
        if (this.state.skipContactCreation) {
            this.openCustomerSelector()
        }

        let redirect = location.pathname
        return <div className="text-align-center" >
            <div className="d-flex flex-row justify-content-center align-items-center flex-wrap">
                <div>
                    <Link to={{
                        pathname: "/contacts/new",
                        state: {
                            cancelRedirectPath: redirect,
                            saveRedirectPath: redirect,
                        }
                    }} className="btn btn-outline-primary btn-sm text-align-right">
                        <FormattedMessage
                            id="quote.edit.project.customer.new_btn"
                            defaultMessage="New customer"
                        />
                    </Link>
                </div>
                <div>
                    &nbsp;
                    <FormattedMessage
                        id="quote.edit.project.customer.or_label"
                        defaultMessage="or"
                    />
                    &nbsp;
                </div>
                <div>
                    <a href="#" onClick={this.openCustomerSelector} className="btn btn-outline-primary btn-sm text-align-left">
                        <FormattedMessage
                            id="quote.edit.project.customer.choose_btn"
                            defaultMessage="Choose existing customer"
                        />
                    </a>
                </div>
            </div>
        </div>
    }

    renderContact() {
        if (this.state.loading) {
            return <div>
                <LoadingSpinner />
            </div>
        }

        var removeCustomerCTA
        if (this.state.isCustomerEditable) {
            removeCustomerCTA =
                <div className="col-md-12">
                    <p className="text-align-right">
                        <a href="#" onClick={this.removeContact} className="btn btn-outline-primary">
                            <Icon value={'retweet'} className={'mr-1'} />
                            <FormattedMessage
                                id="quote.edit.project.customer.change_btn"
                                defaultMessage="Change"
                            />
                        </a>
                    </p>
                </div>
        } else {
            removeCustomerCTA = ''
        }
        let linkContact = this.state.contact.attributes.name
        if (AppContext.getUserLoggedIn().attributes.role.attributes.key !== "worker") {
            linkContact = <Link to={'/contacts/' + this.state.contact.id + '/details'}>
                {this.state.contact.attributes.name}
            </Link>
        }
        let linkCompany = this.state.contactCompany ? this.state.contactCompany.attributes.name : ''
        if (this.state.contactCompany && AppContext.getUserLoggedIn().attributes.role.attributes.key !== "worker") {
            linkCompany = <Link to={'/contacts/' + this.state.contactCompany.id + '/details'}>
                {this.state.contactCompany.attributes.name}
            </Link>
        }

        const address = this.state.contact.attributes.address
        let phoneNumberExtensionString = this.state.contactPrimaryPhoneNumberExtension ? ' ext ' + this.state.contactPrimaryPhoneNumberExtension : ''
        const emailIsValid = GlobalHelper.validateEmail(this.state.contact.attributes.email)

        return <div className="row" >
            <div className="col-md-6">
                <p className="mb-0">
                    <label className="col-12 col-form-label custom-form-label pl-0">
                        <FormattedMessage
                            id="quote.edit.project.customer.name_label"
                            defaultMessage="Name"
                        />
                    </label>
                    {linkContact}
                </p>
                {this.state.contactCompany ? <p className="mb-0">
                    <label className="col-12 col-form-label custom-form-label pl-0">
                        <FormattedMessage
                            id="quote.edit.project.customer.company_label"
                            defaultMessage="Company"
                        />
                    </label>
                    {linkCompany}
                </p> : ''}
                <p className="mb-0">
                    <label className="col-12 col-form-label custom-form-label pl-0">
                        <FormattedMessage
                            id="quote.edit.project.customer.email_label"
                            defaultMessage="Email"
                        />
                    </label>
                    {this.state.contact.attributes.email && emailIsValid &&
                        <a href={'mailto:' + this.state.contact.attributes.email}>
                            {this.state.contact.attributes.email}
                        </a>
                    }
                    {this.state.contact.attributes.email && !emailIsValid &&
                        <Link to={{
                            pathname: "/contacts/" + this.state.contact.id + "/edit",
                            state: {
                                cancelRedirectPath: this.props.location.pathname,
                                saveRedirectPath: this.props.location.pathname,
                                contactType: this.state.contact.type,
                            }
                        }} className='text-danger'>
                            <div>
                                <div>{this.state.contact.attributes.email}</div>
                                <small>
                                    <Icon value={'exclamation'} className={'mr-1'} />
                                    <FormattedMessage
                                        id="customer.view.email_invalid"
                                        defaultMessage="This contact's email is invalid."
                                    />
                                </small>
                            </div>
                        </Link>
                    }
                    {!this.state.contact.attributes.email &&
                        <Link to={{
                            pathname: "/contacts/" + this.state.contact.id + "/edit",
                            state: {
                                cancelRedirectPath: this.props.location.pathname,
                                saveRedirectPath: this.props.location.pathname,
                                contactType: this.state.contact.type,
                            }
                        }} className='text-danger'>
                            <div>
                                <small>
                                    <FormattedMessage
                                        id="customer.view.email_missing"
                                        defaultMessage="This contact doesn't have an email."
                                    />
                                </small>
                            </div>
                        </Link>
                    }
                </p>
            </div>
            <div className="col-md-6">
                {this.state.contactPrimaryPhoneNumber ? <p className="mb-0">
                    <label className="col-12 col-form-label custom-form-label pl-0">
                        <FormattedMessage
                            id="quote.edit.project.customer.phone_label"
                            defaultMessage="Phone number"
                        />
                    </label>
                    <a href={'tel:' + this.state.contactPrimaryPhoneNumber + "," + this.state.contactPrimaryPhoneNumberExtension}>
                        {GlobalHelper.formatPhoneNumber(this.state.contactPrimaryPhoneNumber, address.countryCode) + phoneNumberExtensionString}
                    </a>
                </p> : ''}
                {address.street || address.city || address.country ? <div className="mb-0">
                    <label className="col-12 col-form-label custom-form-label pl-0">
                        <FormattedMessage
                            id="quote.edit.project.customer.address_label"
                            defaultMessage="Address"
                        />
                    </label>
                    <AddressComponent value={address} />
                </div> : ''}
                {this.state.loyaltyBalance ? <div className="mb-0">
                    <label className="col-12 col-form-label custom-form-label pl-0">
                        <FormattedMessage
                            id="quote.edit.project.customer.points_balance_label"
                            defaultMessage="Points balance"
                        />
                    </label>
                    <pre><FormattedNumber value={this.state.loyaltyBalance} /></pre>
                </div> : ''}
                {this.state.contact && this.state.contact.attributes.notes ? <div className="mb-0">
                    <label className="col-12 col-form-label custom-form-label pl-0">
                        <FormattedMessage
                            id="quote.edit.project.customer.notes_label"
                            defaultMessage="Notes"
                        />
                    </label>
                    <pre>{this.state.contact.attributes.notes}</pre>
                </div> : ''}
            </div>
            {removeCustomerCTA}
        </div>
    }

    displayInfoCustomerFirstBanner() {
        if (this.state.showCustomerSectionInfoBanner) {
            return <div className="alert alert-info alert-dismissible fade show" role="alert">
                <FormattedMessage
                    id="quote.edit.project.customer.define_customer_first_banner"
                    defaultMessage="You must first define a customer."
                />
                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        }
        return ""
    }

    render() {
        let box = ''
        if ((this.state.initialContactId && !this.state.contact) || this.state.loading) {
            return <div>
                <LoadingSpinner />
            </div>
        }

        if (this.state.showCustomerSelected) {
            box = this.renderCustomerSelector()
        } else if (this.state.showEmptyBox) {
            box = this.renderEmptyBox()
        } else if ((this.state.renderContactEnabled || this.state.initialContactId) && this.state.contact) {
            box = this.renderContact()
        } else {
            box = this.renderEmptyBox()
        }

        return (
            <div className={this.className + ' row'} >
                <div className="col-12 ui-module">
                    {this.displayInfoCustomerFirstBanner()}
                    {box}
                </div>
                {this.state.modal}
            </div>
        );
    }
}

export default withRouter(ProjectCustomerEditForm)


// WEBPACK FOOTER //
// ./src/quote/project/customerselectform.component.jsx